<template>
    <div class="layout-px-spacing dash_1">
        <teleport to="#breadcrumb">
            <ul class="navbar-nav flex-row">
                <li>
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:;">Dashboard</a></li>
                                <li class="breadcrumb-item active" aria-current="page"><span>Operational Overview</span></li>
                            </ol>
                        </nav>
                    </div>
                </li>
            </ul>
        </teleport>

        <div class="row layout-top-spacing">

            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                <div class="widget widget-recent-orders">
                    <div class="widget-heading">
                        <h5>HVAC Systems</h5>
                    </div>
                    <div class="widget-content table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th><div class="th-content">Site</div></th>
                                    <th><div class="th-content">System</div></th>
                                    <th><div class="th-content">Type</div></th>
                                    <th><div class="th-content">MAC</div></th>
                                    <th><div class="th-content">Port</div></th>
<!--                                    <th><div class="th-content th-heading">Price</div></th>-->
<!--                                    <th><div class="th-content">Status</div></th>-->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in $store.getters.getSystemList">
                                    <td><div class="td-content">{{$store.getters.getSiteNameById(item.site_id)}}</div></td>
                                    <td><div class="td-content">
                                            <span v-if="item.name">{{item.name}}</span>
                                            <span v-else>Не указано</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="td-content"><span>{{$store.getters.getSystemTypeNameById(item.type_id)}}</span></div>
                                    </td>
                                    <td><div class="td-content text-primary"> 
                                            <span v-if="item.mac_address">{{ item.mac_address }}</span>
                                            <span v-else>Не указано</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="td-content">
                                            <span v-if="item.port">{{item.port}}</span>
                                            <span v-else>Не указано</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                <div id="map"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import "../assets/sass/widgets/widgets.scss";
    import {computed, onMounted, ref, shallowRef, watch, watchEffect} from "vue";
    import { useStore } from "vuex";
    import ApexChart from "vue3-apexcharts";

    import { useMeta } from "../composables/use-meta";
    useMeta({ title: "°D VRF" });

    const store = useStore();
    onMounted(async () => {
        let scriptYandexMap = document.createElement('script');
        scriptYandexMap.setAttribute('src', 'https://api-maps.yandex.ru/2.1/?apikey=2a35ce6d-47bc-47e2-a4cc-be4ae43b87c4&lang=ru_RU');
        document.head.appendChild(scriptYandexMap);
        scriptYandexMap.addEventListener('load', () => Promise.all([
            initializeYandexMap()
        ]).then(
            checkSiteList
        ));
        store.dispatch('fetchSystemTypesList')
    })
    const map = shallowRef({})
    const initializeYandexMap = ()=> {
        return new Promise(r => ymaps.ready(() => {
            map.value = new ymaps.Map("map", {
                center: [55.74, 37.53],
                zoom: 9,
                controls: []
            });
            r();
        }));
    }
    const checkSiteList = async () =>{
        if(!store.getters.getSitesList.length){
            let id = store.getters.getCurrentCompany.value
            if(!id){
                await store.dispatch('fetchSitesList')
            } else{
                await store.dispatch('getSiteByCompany', {id})
            }
        }
        setSiteCoords()
    }
    const setSiteCoords= ()=>{
        let result = []
        if(store.getters.getCurrentSite.value){
            let site = store.getters.getSitesList.find(item=>item.id ===store.getters.getCurrentSite.value)
            if(site && site.lat && site.lon){
                result.push([parseFloat(site.lat), parseFloat(site.lon)])
            }
        } else {
            store.getters.getSitesList.forEach(site=>{
                if(site.lat && site.lon){
                    result.push([parseFloat(site.lat), parseFloat(site.lon)])
                }
            })
        }
        
        map.value.geoObjects.removeAll()
        result.forEach(item=>{
            let placemark = new ymaps.Placemark(item, {}, {
                preset: 'islands#blueDotIcon'})
            map.value.geoObjects.add(placemark);
        })

        if(result.length){
            map.value.setCenter(result[0], 17).then()
            // map.value.setBounds(result, {
            //     checkZoomRange: true,
            // })
        }
    }
    const getSiteLocalId = computed(() => {
        return store.getters.getCurrentSite.value
    })
    watch(getSiteLocalId, (newVal, oldVal) => {
        if(map.value){
            setSiteCoords()//смотрим на изменения в сторе
        }
    });
    
    //Revenue
    const revenue_series = ref([
        { name: "Income", data: [16800, 16800, 15500, 17800, 15500, 17000, 19000, 16000, 15000, 17000, 14000, 17000] },
        { name: "Expenses", data: [16500, 17500, 16200, 17300, 16000, 19500, 16000, 17000, 16000, 19000, 18000, 19000] },
    ]);
    const revenue_options = computed(() => {
        const is_dark = store.state.is_dark_mode;
        return {
            chart: {
                fontFamily: "Nunito, sans-serif",
                zoom: { enabled: false },
                toolbar: { show: false },
            },
            dataLabels: { enabled: false },
            stroke: { show: true, curve: "smooth", width: 2, lineCap: "square" },
            dropShadow: { enabled: true, opacity: 0.2, blur: 10, left: -7, top: 22 },
            colors: is_dark ? ["#2196f3", "#e7515a"] : ["#1b55e2", "#e7515a"],
            markers: {
                discrete: [
                    { seriesIndex: 0, dataPointIndex: 6, fillColor: "#1b55e2", strokeColor: "#fff", size: 7 },
                    { seriesIndex: 1, dataPointIndex: 5, fillColor: "#e7515a", strokeColor: "#fff", size: 7 },
                ],
            },
            labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            xaxis: {
                axisBorder: { show: false },
                axisTicks: { show: false },
                crosshairs: { show: true },
                labels: { offsetX: 0, offsetY: 5, style: { fontSize: "12px", fontFamily: "Nunito, sans-serif", cssClass: "apexcharts-xaxis-title" } },
            },
            yaxis: {
                tickAmount: 7,
                labels: {
                    formatter: function (value) {
                        return value / 1000 + "K";
                    },
                    offsetX: -10,
                    offsetY: 0,
                    style: { fontSize: "12px", fontFamily: "Nunito, sans-serif", cssClass: "apexcharts-yaxis-title" },
                },
            },
            grid: {
                borderColor: is_dark ? "#191e3a" : "#e0e6ed",
                strokeDashArray: 5,
                xaxis: { lines: { show: true } },
                yaxis: { lines: { show: false } },
                padding: { top: 0, right: 0, bottom: 0, left: 0 },
            },
            legend: {
                position: "top",
                horizontalAlign: "right",
                offsetY: 0,
                fontSize: "16px",
                fontFamily: "Nunito, sans-serif",
                markers: { width: 10, height: 10, strokeWidth: 0, strokeColor: "#fff", fillColors: undefined, radius: 12, onClick: undefined, offsetX: 0, offsetY: 0 },
                itemMargin: { horizontal: 20, vertical: 5 },
            },
            tooltip: { theme: "dark", marker: { show: true }, x: { show: false } },
            fill: {
                type: "gradient",
                gradient: {
                    type: "vertical",
                    shadeIntensity: 1,
                    inverseColors: !1,
                    opacityFrom: is_dark ? 0.19 : 0.28,
                    opacityTo: 0.05,
                    stops: is_dark ? [100, 100] : [45, 100],
                },
            },
        };
    });

    //Daily Sales
    const daily_sales_series = ref([
        { name: "Sales", data: [44, 55, 41, 67, 22, 43, 21] },
        { name: "Last Week", data: [13, 23, 20, 8, 13, 27, 33] },
    ]);
    const daily_sales_options = computed(() => {
        return {
            chart: { toolbar: { show: false }, stacked: true, stackType: "100%" },
            dataLabels: { enabled: false },
            stroke: { show: true, width: 1 },
            colors: ["#e2a03f", "#e0e6ed"],
            responsive: [{ breakpoint: 480, options: { legend: { position: "bottom", offsetX: -10, offsetY: 0 } } }],
            xaxis: { labels: { show: false }, categories: ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"] },
            yaxis: { show: false },
            fill: { opacity: 1 },
            plotOptions: { bar: { horizontal: false, columnWidth: "25%" } },
            legend: { show: false },
            grid: {
                show: false,
                xaxis: { lines: { show: false } },
                padding: { top: 10, right: -20, bottom: -20, left: -20 },
            },
        };
    });

    //Total Orders
    const total_orders_series = ref([{ name: "Sales", data: [28, 40, 36, 52, 38, 60, 38, 52, 36, 40] }]);
    const total_orders_options = computed(() => {
        const is_dark = store.state.is_dark_mode;
        return {
            chart: { sparkline: { enabled: true } },
            stroke: { curve: "smooth", width: 2 },
            colors: is_dark ? ["#1abc9c"] : ["#fff"],
            labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
            yaxis: { min: 0, show: false },
            grid: { padding: { top: 125, right: 0, bottom: 0, left: 0 } },
            fill: {
                opacity: 1,
                type: "gradient",
                gradient: {
                    type: "vertical",
                    shadeIntensity: 1,
                    inverseColors: !1,
                    opacityFrom: is_dark ? 0.3 : 0.4,
                    opacityTo: 0.05,
                    stops: is_dark ? [100, 100] : [45, 100],
                },
            },
            tooltip: { x: { show: false }, theme: "dark" },
        };
    });

    //Sales by Category
    const sales_donut_series = ref([985, 737, 270]);
    const sales_donut_options = computed(() => {
        const is_dark = store.state.is_dark_mode;
        const option = {
            chart: {},
            dataLabels: { enabled: false },
            expandOnClick: is_dark ? false : true,
            stroke: { show: true, width: 25, colors: is_dark ? "#0e1726" : "#fff" },
            colors: is_dark ? ["#5c1ac3", "#e2a03f", "#e7515a", "#e2a03f"] : ["#e2a03f", "#5c1ac3", "#e7515a"],
            legend: {
                position: "bottom",
                horizontalAlign: "center",
                fontSize: "14px",
                markers: { width: 10, height: 10 },
                height: 50,
                offsetY: 20,
                itemMargin: { horizontal: 8, vertical: 0 },
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: "65%",
                        background: "transparent",
                        labels: {
                            show: true,
                            name: { show: true, fontSize: "29px", fontFamily: "Nunito, sans-serif", offsetY: -10 },
                            value: {
                                show: true,
                                fontSize: "26px",
                                fontFamily: "Nunito, sans-serif",
                                color: is_dark ? "#bfc9d4" : undefined,
                                offsetY: 16,
                                formatter: function (val) {
                                    return val;
                                },
                            },
                            total: {
                                show: true,
                                label: "Total",
                                color: "#888ea8",
                                fontSize: "29px",
                                formatter: function (w) {
                                    return w.globals.seriesTotals.reduce(function (a, b) {
                                        return a + b;
                                    }, 0);
                                },
                            },
                        },
                    },
                },
            },
            labels: ["Apparel", "Sports", "Others"],
        };

        if (is_dark) {
            option["states"] = {
                hover: { filter: { type: "none" } },
                active: { filter: { type: "none" } },
            };
        }

        return option;
    });
</script>
<style lang="scss">
#map{
    width: 100%;
    height: 600px;
}
</style>
